import { CreateMLCEngine, prebuiltAppConfig } from "@mlc-ai/web-llm";

// Pick a valid prebuilt model id (notice the -MLC suffix)
const MODEL_ID = "Qwen2-0.5B-Instruct-q4f16_1-MLC";
// You can console.log(prebuiltAppConfig.model_list.map(m => m.model_id)) to see all options.

let enginePromise = null;

export function webgpuSupported() {
  return typeof navigator !== "undefined" && !!navigator.gpu;
}

export function getEngine() {
  if (!webgpuSupported()) {
    return Promise.reject(new Error("WebGPU not available"));
  }
  if (!enginePromise) {
    enginePromise = CreateMLCEngine(MODEL_ID, {
      initProgressCallback: (p) => {
        // You can wire this to UI state via the Provider below
        console.log("[WebLLM]", p.text, Math.round((p.progress ?? 0) * 100) + "%");
      },
    });
  }
  return enginePromise;
}

// Optional: “warm up” the model once after load to remove first-token lag
export async function warmupEngine() {
  const engine = await getEngine();
  try {
    await engine.chat.completions.create({
      messages: [{ role: "user", content: "Say OK." }],
      max_tokens: 1,
      temperature: 0.0,
    });
  } catch {}
  return engine;
}
